import PropTypes from 'prop-types'
import React from 'react'
import { Grid, Skeleton } from 'gu-ui-kit'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'

const Placeholder = ({ className = '' }) => {
  const breakpoint = useBreakpoint()

  return (
    <Skeleton
      shown
      className={className}
    >
      <Skeleton.Item
        className={'margin-bottom-24'}
        width={'60%'}
        height={breakpoint.lg ? 40 : breakpoint.fb ? 28 : 36}
      />

      <Grid
        display={breakpoint.lg ? 'column' : 'row'}
        wrap={false}
        gap={8}
      >
        {Array.apply(null, Array(5)).map((val, i) => (
          <Skeleton.Item
            key={i}
            width={breakpoint.lg ? '100%' : 250}
            style={{ minWidth: breakpoint.lg ? '100%' : 250 }}
            height={114}
          />
        ))}
      </Grid>
    </Skeleton>
  )
}

export default Placeholder

Placeholder.propTypes = {
  className: PropTypes.string,
}
